import sumBy from 'lodash/sumBy';
import {
  cancelForAnyReason,
  checkInBaggage,
  climateCompensation,
  flexibleTicket,
} from '@eti/products';
import type { PreSelectedExtraProducts } from '../../../models';

export const preSelectedExtraProductsData = (
  preSelectedExtraProducts: PreSelectedExtraProducts[],
) => {
  const relevantProductIds: number[] = [
    cancelForAnyReason.id,
    checkInBaggage.id,
    flexibleTicket.id,
    climateCompensation.id,
  ];

  const result = (preSelectedExtraProducts || []).reduce(
    (acc, product) => {
      if (product.productId === cancelForAnyReason.id) {
        acc.hasCFARTicketPreSelected = true;
      }
      if (product.productId === checkInBaggage.id) {
        acc.hasCheckedBaggagePreSelected = true;
      }
      if (product.productId === flexibleTicket.id) {
        acc.hasFlexTicketPreSelected = true;
      }
      if (relevantProductIds.includes(product.productId)) {
        acc.hasPreSelectedProducts = true;
      }
      return acc;
    },
    {
      hasCFARTicketPreSelected: false,
      hasCheckedBaggagePreSelected: false,
      hasFlexTicketPreSelected: false,
      hasPreSelectedProducts: false,
    },
  );

  const totalPricePreSelectedProducts = sumBy(preSelectedExtraProducts, 'price');

  return {
    ...result,
    totalPricePreSelectedProducts,
  };
};
